import React, { useRef } from 'react';
var VeltNotificationsPanelContentPeopleListItemName = function (props) {
    var data = props.data, notificationIndex = props.notificationIndex, defaultCondition = props.defaultCondition, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-notifications-panel-content-people-list-item-name", { ref: ref, "notification-index": notificationIndex, "default-condition": [true, false].includes(defaultCondition) ? (defaultCondition ? 'true' : 'false') : undefined, data: data ? (typeof data === "string" ? data : JSON.stringify(data)) : undefined }, children));
};
export default VeltNotificationsPanelContentPeopleListItemName;
